var _ellipse, _ellipse2, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7202,
    cy: 24,
    rx: 24.0698,
    ry: 24,
    fill: "#CED4DA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3315_6931",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7202,
    cy: 24,
    rx: 24.0698,
    ry: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3315_6931)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.6504,
    y: -1,
    width: 8,
    height: 54,
    transform: "rotate(32 34.6504 -1)",
    fill: "white",
    fillOpacity: 0.101961
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6504 13H22.6504C21.5474 13 20.6504 13.897 20.6504 15V19H16.6504C15.5474 19 14.6504 19.897 14.6504 21V31C14.6504 32.103 15.5474 33 16.6504 33H26.6504C27.7534 33 28.6504 32.103 28.6504 31V27H32.6504C33.7534 27 34.6504 26.103 34.6504 25V15C34.6504 13.897 33.7534 13 32.6504 13V13ZM16.6504 31V21H26.6504L26.6524 31H16.6504V31ZM32.6504 25H28.6504V21C28.6504 19.897 27.7534 19 26.6504 19H22.6504V15H32.6504V25V25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6504 23H24.6504V25H18.6504V23ZM18.6504 27H24.6504V29H18.6504V27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItem);
export default __webpack_public_path__ + "static/media/NoItem.596c8322.svg";
export { ForwardRef as ReactComponent };